export default __webpack_public_path__ + "static/media/Versions - vs Official vs Films_00.8c286336.jpg";